// extracted by mini-css-extract-plugin
module.exports = {"fallback":"ErrorFallback_fallback__J2iq9","container":"ErrorFallback_container__0ii0b","actions":"ErrorFallback_actions__3n0Cq"};